import React, { Component } from 'react';
import * as Icon from 'react-feather';
import { getUserProjects } from '../services/projectService';
import SyncLoader from "react-spinners/SyncLoader";
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import InstitutionViewer from './forms/Viewer/QA_Viewer/institution_viewer';

class ProjectHeader extends Component {
	constructor(props) {
		super(props);

		const queryParameters = queryString.parse(props.location.search);

		this.state = {
			projects: [],
			selected_project: {},
			Form: null,
			loading: false,
			queryParameters,
			triggerRender: false,
			selectedInst: queryString.parse(window.location.search).inst_id ? queryString.parse(window.location.search).inst_id : 0,
			error: false
		};
		this.handleResponse = this.handleResponse.bind(this);
	}

	async componentDidMount() {
		this.setState({ loading: true });
		const { queryParameters } = this.state, { data: projects } = await getUserProjects();
		this.setState({ projects });
		if (typeof projects === 'string') {
			console.error('No institutions assigned to user')
		}
		else if (!_.isEmpty(queryParameters) && queryParameters.project_id && !queryParameters.form_id) {
			const projectSelected = _(projects).find(obj => obj.Project_ID === parseInt(queryParameters.project_id));
			this.handleProjectSelection(projectSelected);
		}
		else if (projects.length > 0 && !queryParameters.form_id) {
			this.handleProjectSelection(projects[0]);
			window.history.replaceState(null, null, `/projectViewer?project_id=${projects[0].Project_ID}`)
		}
		else if(queryParameters.form_id){
			const projectSelected = _(projects).find(obj => obj.Project_ID === parseInt(queryParameters.project_id));
			this.setState({ selected_project: projectSelected });
		}
		(this.state.selected_project).toString()!=='{}' && this.setState({ loading: false });
	}

	handleProjectSelection = (project) => {
		const { history } = this.props;
		history.push(`/projectViewer?project_id=${project.Project_ID}`)
		this.setState({ selected_project: project });
	};

	reloadProject(project) {
		this.handleProjectSelection(project)
		window.location.reload();
	}

	handleResponse() {
		this.props.OnUpdate()
	}

	render() {
		if (this.state.loading) {
			return <SyncLoader size={8} color={"#0061f2"} loading={this.state.loading} />;
		}

		const { selected_project } = this.state;
		//console.log("selected_project", selected_project)

		return (
			<React.Fragment>
				<header className='pb-2 ml-20'>
					<div className='page-header-content pt-2'>
						<div className='row align-items-center justify-content-between'>
							<div id='projectSelected' name={selected_project.Project_ID} className='col-xl btn btn-transparent-dark' onClick={() => this.props.history.push(`/projectViewer?project_id=${selected_project.Project_ID}`)}>
								<h1 className='page-header-title mt-1'>
									<Icon.Bookmark />
									{selected_project.Project_Name}
								</h1>
							</div>
							<div className='col-12 col-xl-auto mt-3 ml-15'>
								<InstitutionViewer
									Question_ID={0}
									Response_Required={false}
									OnUpdate={this.handleResponse}
									Question_Number={this.props.Question_Number}
									PrimaryKey={this.state.PrimaryKey}
									Project_ID={this.state.Project_ID}
									Answer_ID={this.state.selectedInst}
									isMultiple={false}
									isTopLevel={true}
									selectedInst={this.state.selectedInst}
								/>
							</div>
							<div className='col-12 col-xl-auto'>
								<button className='btn btn-primary dropdown-toggle' type='button' id='project_select' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
									Switch Project
								</button>
								<div className='dropdown-menu' aria-labelledby='project_select'>
									{this.state.projects.map((project) => {
										return (
											<button className='dropdown-item' type='button' key={project.Project_ID} value={project.Project_ID} onClick={() => this.reloadProject(project)}>
												{project.Project_Name}
											</button>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</header>
			</React.Fragment>
		);
	}
}

export default withRouter(ProjectHeader);
